import { AuthGuardData, createAuthGuard } from 'keycloak-angular';
import { ActivatedRouteSnapshot, CanActivateFn, Router, RouterStateSnapshot, UrlTree } from '@angular/router';
import { inject } from '@angular/core';
import { ThemeService } from '../services/theme.service';

/**
 * The logic below is a simple example, please make it more robust when implementing in your application.
 *
 * Reason: isAccessGranted is not validating the resource, since it is merging all roles. Two resources might
 * have the same role name and it makes sense to validate it more granular.
 */
const isAccessAllowed = async (
    route: ActivatedRouteSnapshot,
    __: RouterStateSnapshot,
    authData: AuthGuardData
): Promise<boolean | UrlTree> => {
    const { authenticated, grantedRoles, keycloak } = authData;
    const router = inject(Router);

    if (!authenticated) {
        try {
            // Inyectamos ThemeService al principio del guard 
            const themeService = inject(ThemeService);
            let isDarkMode = false;
            
            // Obtener el tema actual
            themeService.theme$.subscribe(theme => {
                isDarkMode = theme === 'dark';
            }).unsubscribe();
            
            // Modificar directamente la URL de login
            const loginUrl = await keycloak.createLoginUrl();
            
            const darkParam = `&dark=${isDarkMode ? 'true' : 'false'}`;
            
            // Añadir el parámetro dark a la URL existente
            window.location.href = `${loginUrl}${darkParam}`;
            return false;
        } catch (error) {
            console.error('Error al redirigir a login:', error);
            // Si hay un error, intentar con el método normal
            await keycloak.login();
            return false;
        }
    }
    

    // const requiredRole = route.data['role'];
    // if (!requiredRole) {
    //     return false;
    // }

    // const hasRequiredRole = (role: string): boolean =>
    //     Object.values(grantedRoles.resourceRoles).some((roles) => roles.includes(role));

    if (authenticated) {
        return true;
    }

    return router.parseUrl('/forbidden');
};

export const canActivateAuthRole = createAuthGuard<CanActivateFn>(isAccessAllowed);